import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import { CloudStagingListNirvanaDataProvider } from '../dataProvider/CloudStagingListNirvanaDataProvider';
import { GridConfig } from './GridConfig';
import { GridViewMetadata, ViewConfiguration, ViewType } from '../../../grid/gridView/types';
import { Column, ColumnKeys, osTypes } from '../types';
import { GridTitleConfig } from '../../../grid/uiElements/gridViewTitle/types';
import { GridViewWebComponent } from '../../../grid/gridView';
import { WEB_COMPONENT_CLOUD_STAGING_SIDE_BAR, WEB_COMPONENT_GRID_VIEW } from '../../../webcomponents.constants';
import { CloudStagingSideBarWebComponent } from '../../cloudStagingSideBar';
import { GzTextWebComponent } from '../../../ui/gzText';
import { htmlEncode } from '../../../utils/escape.utils';
import { getProductChangelogLink } from './productChangelogLinks';
import { GzTitleWebComponent } from '../../../ui/gzTitle';
import { LinkType } from 'apps/webcomponents/src/ui/gzLinkComponent/types';

export class CloudStagingListView extends BaseWebComponentView {
  public getDomElements(): void {
    this.dom.$hostElement = this.shadow;
    this.dom.$grid = this.shadow.querySelector(WEB_COMPONENT_GRID_VIEW) as GridViewWebComponent<Column, ColumnKeys>;
    this.dom.$gridInfoText = this.shadow.querySelector('#subtitle-info-text') as GzTextWebComponent;
    this.dom.$changelogText = this.shadow.querySelector('#product-changelog-text') as GzTextWebComponent;
    this.dom.$gridTitle = this.shadow.querySelector('#grid-title') as GzTitleWebComponent;
    this.dom.$gridTitleTooltip = this.shadow.querySelector('#grid-title-tooltip');
    this.dom.$cloudStagingSideBar = this.shadow.querySelector(
      WEB_COMPONENT_CLOUD_STAGING_SIDE_BAR
    ) as CloudStagingSideBarWebComponent;

    // side nav texts translated
    this.dom.$cloudStagingSideBar.label = this.dependencies.translateFn('Products');
    this.dom.$cloudStagingSideBar.windows = this.dependencies.translateEndpointProductTypes(osTypes.windows);
    this.dom.$cloudStagingSideBar.mac = this.dependencies.translateEndpointProductTypes(osTypes.mac);
    this.dom.$cloudStagingSideBar.linux = this.dependencies.translateEndpointProductTypes(osTypes.linux);
    this.dom.$gridInfoText.innerHTML = `${htmlEncode(
      this.dependencies.translateFn(
        'Deploy product versions to endpoints in user-defined staging rings, as configured in policies. You can assign a version to multiple rings. The latest versions released to the Bitdefender-defined fast and slow rings are indicated in brackets.'
      )
    )}`;
    const kbLink = getProductChangelogLink(osTypes.windows, this.dependencies.canHaveChildCompanies());
    this.dom.$changelogText.innerHTML = `<gz-link
        type="${LinkType.UNDERLINE}"
        href="${kbLink}"
        ><span>${htmlEncode(this.dependencies.translateFn('Product changelog'))}</span></gz-link
      >`;

    this.dom.$filtersTitle = this.shadow.getElementById('filtersTitle');
    this.dom.$filtersTitle.innerHTML = this.dependencies.translateFn('Update staging').toUpperCase();

    this.dom.$gridTitle.innerText = this.dependencies.translateEndpointProductTypesTitle(osTypes.windows);
    this.dom.$gridTitleTooltip.tooltipText = this.dependencies.translateEndpointProductTypesTitle(osTypes.windows);

    this.injectDependenciesInChildren();
  }

  private injectDependenciesInChildren() {
    if (this.dom.$grid.injectDependencies) {
      this.dom.$grid.injectDependencies(this.dependencies);
      this.dom.$grid.start().catch(console.error);
    }
  }
  public buildView(): void {
    const { viewMetaData } = new GridConfig().getDataForView(this.dom.$grid, this.dependencies);

    this.buildGrid(viewMetaData);
  }

  private buildGrid(viewMetaData: GridViewMetadata<Column, ColumnKeys>): void {
    const grid = this.dom.$grid;

    const defaultViewProps: ViewConfiguration<Column, ColumnKeys> = {
      compactView: viewMetaData.isCompactViewChecked,
      displayedColumns: viewMetaData.columns,
      filters: viewMetaData.filters,
      name: '',
      pageSize: viewMetaData.pageSize,
      type: ViewType.DEFAULT,
      id: viewMetaData.viewId,
    };

    grid.propertiesSet = false;
    grid.dataProvider = new CloudStagingListNirvanaDataProvider(this.dependencies);
    grid.sideMenuParent = this.dom.$hostElement;

    for (const [key, value] of Object.entries(viewMetaData)) {
      grid[key] = value;
    }

    grid.extraParams = {};
    grid.defaultViewProps = defaultViewProps;
    grid.propertiesSet = true;

    grid.injectDependencies(this.dependencies);
    grid.start().catch();
  }
}
